import { render, staticRenderFns } from "./PanelDynamicEventsAnnouncesV2.vue?vue&type=template&id=80e24766&scoped=true"
import script from "./PanelDynamicEventsAnnouncesV2.vue?vue&type=script&lang=js"
export * from "./PanelDynamicEventsAnnouncesV2.vue?vue&type=script&lang=js"
import style0 from "./PanelDynamicEventsAnnouncesV2.vue?vue&type=style&index=0&id=80e24766&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80e24766",
  null
  
)

export default component.exports